module.exports = __webpack_public_path__ + "static/media/BrandonGrotesque-Light.4147f3fd.otf";